import { z } from 'zod';

export const CONSUMABLE_UNITS = [
  'unit',
  'm',
  'ft',
  'm2',
  'ft2',
  'm3',
  'ft3',
  'litre',
  'kg',
  'hour',
] as const;

export const ConsumableUnit = z.enum(CONSUMABLE_UNITS);

export type ConsumableUnit = z.infer<typeof ConsumableUnit>;

export const CONSUMABLE_UNIT_LABELS: Record<ConsumableUnit, string> = {
  unit: 'unit',
  m: 'm',
  ft: 'ft',
  m2: 'm²',
  ft2: 'ft²',
  m3: 'm³',
  ft3: 'ft³',
  litre: 'litre',
  kg: 'kg',
  hour: 'hour',
};

export function consumableUnitLabel(unit: ConsumableUnit): string {
  return CONSUMABLE_UNIT_LABELS[unit];
}

/** Quantity with its unit, leaving plain counts unlabeled (`4`, `3 m²`). */
export function consumableQuantityLabel(
  quantity: string | number,
  unit: ConsumableUnit,
): string {
  const amount = String(Number(quantity));
  return unit === 'unit' ? amount : `${amount} ${consumableUnitLabel(unit)}`;
}

export const Consumable = z.object({
  id: z.number(),
  name: z.string(),
  cost: z.string(),
  unit: ConsumableUnit,
  description: z.string(),
  is_archived: z.boolean(),
});

export type Consumable = z.infer<typeof Consumable>;

export const ConsumableLink = z.object({
  consumable: Consumable,
  quantity: z.string(),
});

export type ConsumableLink = z.infer<typeof ConsumableLink>;

export interface ConsumableSelection {
  consumable_id: number;
  quantity: string;
}

export interface ConsumableWrite {
  name: string;
  cost: string;
  unit: ConsumableUnit;
  description?: string;
  is_archived?: boolean;
}

export function consumableSelectionsFromLinks(
  links: ConsumableLink[] | undefined,
): ConsumableSelection[] {
  return (links ?? []).map((link) => ({
    consumable_id: link.consumable.id,
    quantity: link.quantity,
  }));
}
